import React from 'react';
import { 
  Card, 
  CardContent, 
  Grid, 
  TextField, 
  MenuItem, 
  Button, 
  Typography,
  Box,
  makeStyles 
} from '@material-ui/core';
import { FilterList, Clear } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  filterCard: {
    marginBottom: theme.spacing(3),
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  },
  filterHeader: {
    padding: theme.spacing(2, 3),
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.grey[50],
  },
  filterContent: {
    padding: theme.spacing(3),
  },
  clearButton: {
    marginTop: theme.spacing(2),
    borderRadius: 8,
    borderColor: '#667eea',
    color: '#667eea',
    fontWeight: 600,
    '&:hover': {
      borderColor: '#5a67d8',
      backgroundColor: 'rgba(102, 126, 234, 0.04)',
      color: '#5a67d8',
    },
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
    },
    '& .MuiSelect-select': {
      color: 'rgba(0, 0, 0, 0.87)',
    },
    '& .MuiSelect-select:empty': {
      color: 'rgba(0, 0, 0, 0.54)',
    },
    '& .MuiInputLabel-root': {
      color: 'rgba(0, 0, 0, 0.54)',
    },
    '& .MuiInputLabel-shrink': {
      color: '#667eea',
    },
  },
}));

const MeetingFilters = ({ filters, onFilterChange, organizers }) => {
  const classes = useStyles();

  const handleFilterChange = (key, value) => {
    onFilterChange(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const clearFilters = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    
    const formatDateForInput = (date) => {
      return date.toISOString().split('T')[0];
    };

    onFilterChange({
      dateStart: formatDateForInput(today),
      dateEnd: formatDateForInput(tomorrow),
      organizer: '',
      status: '',
      joined: '',
    });
  };

  return (
    <Card className={classes.filterCard}>
      <Box className={classes.filterHeader}>
        <Typography variant="h6" component="h2">
          <FilterList style={{ marginRight: 8, verticalAlign: 'middle' }} />
          Filtros
        </Typography>
      </Box>
      <CardContent className={classes.filterContent}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              label="Fecha desde"
              type="date"
              variant="outlined"
              size="small"
              className={classes.textField}
              value={filters.dateStart}
              onChange={(e) => handleFilterChange('dateStart', e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              label="Fecha hasta"
              type="date"
              variant="outlined"
              size="small"
              className={classes.textField}
              value={filters.dateEnd}
              onChange={(e) => handleFilterChange('dateEnd', e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              select
              label="Organizador"
              variant="outlined"
              size="small"
              className={classes.textField}
              value={filters.organizer}
              onChange={(e) => handleFilterChange('organizer', e.target.value)}
              displayEmpty
              InputLabelProps={{
                shrink: true,
              }}
              SelectProps={{
                displayEmpty: true,
                renderValue: (selected) => {
                  if (!selected || selected === '') {
                    return 'Todos los organizadores';
                  }
                  return selected;
                },
              }}
            >
              <MenuItem value="">Todos los organizadores</MenuItem>
              {organizers.map((organizer) => (
                <MenuItem key={organizer} value={organizer}>
                  {organizer}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              select
              label="Estado"
              variant="outlined"
              size="small"
              className={classes.textField}
              value={filters.status}
              onChange={(e) => handleFilterChange('status', e.target.value)}
              displayEmpty
              InputLabelProps={{
                shrink: true,
              }}
              SelectProps={{
                displayEmpty: true,
                renderValue: (selected) => {
                  if (!selected || selected === '') {
                    return 'Todos los estados';
                  }
                  const statusLabels = {
                    'not_started': 'No Iniciada',
                    'in_progress': 'En Curso',
                    'ended': 'Finalizada'
                  };
                  return statusLabels[selected] || selected;
                },
              }}
            >
              <MenuItem value="">Todos los estados</MenuItem>
              <MenuItem value="not_started">No Iniciada</MenuItem>
              <MenuItem value="in_progress">En Curso</MenuItem>
              <MenuItem value="ended">Finalizada</MenuItem>
            </TextField>
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: 8 }}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              select
              label="Estado del organizador"
              variant="outlined"
              size="small"
              className={classes.textField}
              value={filters.joined}
              onChange={(e) => handleFilterChange('joined', e.target.value)}
              displayEmpty
              InputLabelProps={{
                shrink: true,
              }}
              SelectProps={{
                displayEmpty: true,
                renderValue: (selected) => {
                  if (!selected || selected === '') {
                    return 'Todos';
                  }
                  const joinedLabels = {
                    'joined': 'Se ha unido',
                    'not_joined': 'No se ha unido'
                  };
                  return joinedLabels[selected] || selected;
                },
              }}
            >
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="joined">Se ha unido</MenuItem>
              <MenuItem value="not_joined">No se ha unido</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Box display="flex" alignItems="flex-end" height="100%">
              <Button
                variant="outlined"
                className={`${classes.clearButton} teams-clear-button`}
                onClick={clearFilters}
                startIcon={<Clear />}
              >
                Limpiar filtros
              </Button>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export { MeetingFilters };
export default MeetingFilters;